var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    [
      _c(
        "nav",
        {
          staticClass:
            "navbar navbar-expand-lg navbar-color fixed-top p-0 text-right"
        },
        [
          _c("div", { staticClass: "container-xl pl-0 pl-xl-3" }, [
            _c(
              "a",
              {
                staticClass: "navbar-brand p-3 mr-0 mr-sm-3",
                attrs: { href: "/" }
              },
              [
                _c("img", {
                  staticClass: "d-inline-block",
                  attrs: {
                    alt: "omegaUp",
                    src: "/media/omegaup_curves.png",
                    height: "20"
                  }
                }),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.omegaUpLockDown,
                      expression: "omegaUpLockDown"
                    }
                  ],
                  class: { "d-inline-block": _vm.omegaUpLockDown },
                  attrs: {
                    alt: "lockdown",
                    title: "lockdown",
                    src: _vm.lockDownImage,
                    height: "20"
                  }
                })
              ]
            ),
            _c("div", { staticClass: "d-inline-flex d-flex-row order-lg-1" }, [
              _vm.isLoggedIn
                ? _c(
                    "div",
                    {
                      staticClass:
                        "navbar-nav navbar-right align-items-end d-lg-none"
                    },
                    [
                      _vm.inContest
                        ? _c("omegaup-notifications-clarifications", {
                            attrs: { clarifications: _vm.clarifications }
                          })
                        : _c("omegaup-notification-list", {
                            attrs: { notifications: _vm.notifications },
                            on: { read: _vm.readNotifications }
                          })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isLoggedIn
                ? _c(
                    "ul",
                    { staticClass: "navbar-nav navbar-right d-lg-flex" },
                    [
                      _c("li", { staticClass: "nav-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link nav-login-text",
                            attrs: {
                              href: _vm.formattedLoginURL,
                              "data-login-button": ""
                            }
                          },
                          [_vm._v(_vm._s(_vm.T.navLogIn))]
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._m(0)
            ]),
            _c(
              "div",
              { staticClass: "collapse navbar-collapse omegaup-navbar" },
              [
                _c("omegaup-navbar-items", {
                  attrs: {
                    "omega-up-lock-down": _vm.omegaUpLockDown,
                    "in-contest": _vm.inContest,
                    "is-logged-in": _vm.isLoggedIn,
                    "is-reviewer": _vm.isReviewer,
                    "is-admin": _vm.isAdmin,
                    "is-main-user-identity": _vm.isMainUserIdentity,
                    "is-under13-user": _vm.isUnder13User,
                    "navbar-section": _vm.navbarSection
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm.hasTeachingObjective
                        ? {
                            key: "contests-items",
                            fn: function() {
                              return [
                                _vm.isMainUserIdentity
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          href: "/contest/new/",
                                          "data-nav-contests-create": ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.T.contestsCreate) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: {
                                      href: "/arena/",
                                      "data-nav-contests-arena": ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.T.navViewContests) + " "
                                    )
                                  ]
                                ),
                                _vm.isMainUserIdentity
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: { href: "/scoreboardmerge/" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.T.contestsJoinScoreboards
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            },
                            proxy: true
                          }
                        : null,
                      _vm.hasTeachingObjective
                        ? {
                            key: "courses-items",
                            fn: function() {
                              return [
                                _vm.isMainUserIdentity
                                  ? [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: {
                                            href: "/course/new/",
                                            "data-nav-courses-create": ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.T.courseCreate) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e(),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: {
                                      href: "/course/",
                                      "data-nav-courses-all": ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.T.navViewCourses) + " "
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        : null,
                      _vm.hasTeachingObjective
                        ? {
                            key: "problems-items",
                            fn: function() {
                              return [
                                _vm.isLoggedIn && _vm.isMainUserIdentity
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          href: "/problem/new/",
                                          "data-nav-problems-create": ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.T.myproblemsListCreateProblem
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: {
                                      href: "/problem/collection/",
                                      "data-nav-problems-collection": ""
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.T.navViewProblems))]
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: { href: "/submissions/" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.T.navViewLatestSubmissions)
                                    )
                                  ]
                                ),
                                _vm.isReviewer
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: { href: "/nomination/" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.T.navQualityNominationQueue
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            },
                            proxy: true
                          }
                        : null
                    ],
                    null,
                    true
                  )
                }),
                _c(
                  "div",
                  { staticClass: "d-flex px-3 justify-content-between" },
                  [
                    _vm.isLoggedIn
                      ? _c(
                          "ul",
                          {
                            staticClass:
                              "navbar-nav navbar-right align-items-right"
                          },
                          [
                            _c(
                              "li",
                              { staticClass: "d-none d-lg-flex" },
                              [
                                _vm.inContest
                                  ? _c("omegaup-notifications-clarifications", {
                                      attrs: {
                                        clarifications: _vm.clarifications
                                      }
                                    })
                                  : _c("omegaup-notification-list", {
                                      attrs: {
                                        notifications: _vm.notifications
                                      },
                                      on: { read: _vm.readNotifications }
                                    })
                              ],
                              1
                            ),
                            _c(
                              "li",
                              {
                                staticClass:
                                  "nav-item dropdown nav-user nav-item-align",
                                attrs: { "data-nav-right": "" }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "nav-link px-2 dropdown-toggle nav-user-link",
                                    attrs: {
                                      href: "#",
                                      role: "button",
                                      "data-nav-user": "",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "pr-1 pt-1",
                                      attrs: {
                                        src: _vm.gravatarURL51,
                                        height: "45"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "username mr-2",
                                        attrs: { title: _vm.currentUsername }
                                      },
                                      [_vm._v(_vm._s(_vm.currentUsername))]
                                    ),
                                    _c("omegaup-common-grader-badge", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isAdmin,
                                          expression: "isAdmin"
                                        }
                                      ],
                                      staticClass: "mr-1",
                                      attrs: {
                                        "queue-length": _vm.graderQueueLength,
                                        error: _vm.errorMessage !== null
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right allow-overflow h-auto overflow-auto",
                                    attrs: { "data-dropdown-menu": "" }
                                  },
                                  [
                                    !_vm.omegaUpLockDown &&
                                    (!_vm.inContest || _vm.isAdmin)
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "text-center mb-1" },
                                            [
                                              _c("img", {
                                                staticClass:
                                                  "rounded-circle mb-1",
                                                attrs: {
                                                  src: _vm.gravatarURL128,
                                                  height: "70",
                                                  title: _vm.currentUsername
                                                }
                                              }),
                                              _vm.currentName !== ""
                                                ? _c(
                                                    "h5",
                                                    { staticClass: "mx-2" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.currentName
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "h5",
                                                    { staticClass: "mx-2" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.currentUsername
                                                        )
                                                      )
                                                    ]
                                                  ),
                                              _c(
                                                "h6",
                                                { staticClass: "mx-2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.currentEmail)
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    !_vm.omegaUpLockDown &&
                                                    (!_vm.inContest ||
                                                      _vm.isAdmin),
                                                  expression:
                                                    "!omegaUpLockDown && (!inContest || isAdmin)"
                                                }
                                              ],
                                              staticClass:
                                                "dropdown-item text-center",
                                              attrs: {
                                                "data-nav-profile": "",
                                                href: "/profile/"
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: { icon: ["fas", "user"] }
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.T.navViewProfile) +
                                                  " "
                                              ),
                                              _vm.profileProgress !== 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "progress mt-2"
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "progress-bar progress-bar-striped bg-info",
                                                        style: {
                                                          width:
                                                            _vm.profileProgress +
                                                            "%"
                                                        },
                                                        attrs: {
                                                          role: "progressbar",
                                                          "aria-valuenow":
                                                            _vm.profileProgress,
                                                          "aria-valuemin": "0",
                                                          "aria-valuemax": "100"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _c("div", {
                                            staticClass: "dropdown-divider"
                                          }),
                                          _vm.identitiesNotLoggedIn.length > 0
                                            ? _c(
                                                "div",
                                                { staticClass: "mb-1" },
                                                [
                                                  _vm._l(
                                                    _vm.identitiesNotLoggedIn,
                                                    function(identity) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: identity.username
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-link dropdown-item",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.$emit(
                                                                    "change-account",
                                                                    identity.username
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "rounded-circle mr-3",
                                                                attrs: {
                                                                  src:
                                                                    _vm.gravatarURL51,
                                                                  height: "45",
                                                                  title:
                                                                    identity.username
                                                                }
                                                              }),
                                                              _vm._v(
                                                                _vm._s(
                                                                  identity.username
                                                                ) + " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _c("div", {
                                                    staticClass:
                                                      "dropdown-divider"
                                                  })
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: { href: "/badge/list/" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.T.navViewBadges)
                                              )
                                            ]
                                          ),
                                          _vm.hasTeachingObjective
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    attrs: {
                                                      href: "/problem/mine"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.T.navMyProblems
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    attrs: {
                                                      href: "/course/mine",
                                                      "data-nav-courses-mine":
                                                        ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.T.navMyCourses)
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    attrs: {
                                                      href: "/contest/mine",
                                                      "data-nav-user-contests":
                                                        ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.T.navMyContests
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    attrs: {
                                                      href:
                                                        "/profile/#created-content"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.T.navMyContent)
                                                    )
                                                  ]
                                                )
                                              ]
                                            : [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    attrs: {
                                                      href: "/profile/#problems"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.T.navProfileProblems
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    attrs: {
                                                      href: "/course/#enrolled",
                                                      "data-nav-courses-mine":
                                                        ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.T.navCoursesEnrolled
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    attrs: {
                                                      href:
                                                        "/arena/?page=1&tab_name=current&sort_order=none&filter=signedup",
                                                      "data-nav-user-contests-enrolled":
                                                        ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.T
                                                          .navContestsEnrolled
                                                      )
                                                    )
                                                  ]
                                                ),
                                                !_vm.isUnder13User
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "dropdown-item",
                                                        attrs: {
                                                          href: "/dependents"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.T.navDependents
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                !_vm.isUnder13User
                                                  ? _c(
                                                      "form",
                                                      {
                                                        staticClass:
                                                          "collapse-submenu"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "btn-group"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                attrs: {
                                                                  href:
                                                                    "/profile/#created-content"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.T
                                                                      .navMyContent
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c("button", {
                                                              staticClass:
                                                                "btn dropdown-item dropdown-toggle dropdown-toggle-split",
                                                              attrs: {
                                                                type: "button",
                                                                "data-toggle":
                                                                  "collapse",
                                                                "data-target":
                                                                  ".collapse-links",
                                                                "aria-expanded":
                                                                  "false",
                                                                "aria-controls":
                                                                  "collapse-links"
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "collapse collapse-links pl-3"
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                attrs: {
                                                                  href:
                                                                    "/problem/mine"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.T
                                                                      .navMyProblems
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                attrs: {
                                                                  href:
                                                                    "/course/mine",
                                                                  "data-nav-courses-mine":
                                                                    ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.T
                                                                      .navMyCourses
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "dropdown-item",
                                                                attrs: {
                                                                  href:
                                                                    "/contest/mine",
                                                                  "data-nav-user-contests":
                                                                    ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.T
                                                                      .navMyContests
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: {
                                                href: "/group/",
                                                "data-nav-user-groups": ""
                                              }
                                            },
                                            [_vm._v(_vm._s(_vm.T.navMyGroups))]
                                          ),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: {
                                                href: "/teamsgroup/",
                                                "data-nav-user-teams-groups": ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.T.navMyTeamsGroups)
                                              )
                                            ]
                                          ),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: {
                                                href: "/nomination/mine/"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.T.navMyQualityNomination
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _c("div", {
                                      staticClass: "dropdown-divider"
                                    }),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          href: "#",
                                          "data-logout-button": ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.logoutModalVisible = true
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: ["fas", "power-off"] }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.T.omegaupTitleLogout) +
                                            " "
                                        )
                                      ],
                                      1
                                    ),
                                    _c("omegaup-common-grader-status", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isAdmin,
                                          expression: "isAdmin"
                                        }
                                      ],
                                      attrs: {
                                        status:
                                          _vm.errorMessage !== null
                                            ? "down"
                                            : "ok",
                                        error: _vm.errorMessage,
                                        "grader-info": _vm.graderInfo
                                      }
                                    })
                                  ],
                                  2
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.isLoggedIn
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "navbar justify-content-end d-lg-none align-items-start pt-4 d-flex align-items-center",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.logoutModalVisible = true
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "power-off"] }
                            }),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v(
                                " " + _vm._s(_vm.T.omegaupTitleLogout) + " "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            ),
            _vm.isLoggedIn
              ? _c(
                  "a",
                  {
                    staticClass:
                      "navbar justify-content-end d-none d-lg-block order-1",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.logoutModalVisible = true
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "power-off"] }
                    }),
                    _vm._v(" " + _vm._s(_vm.T.omegaupTitleLogout) + " ")
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      ),
      _vm.userVerificationDeadline
        ? _c("div", { staticClass: "py-2 mt-2", class: _vm.bannerColor }, [
            _c("div", { staticClass: "container-xl" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.daysUntilVerificationDeadline > 1
                      ? _vm.ui.formatString(_vm.T.bannerVerifyAccount, {
                          days: _vm.daysUntilVerificationDeadline
                        })
                      : _vm.T.bannerLastDayToVerifyAccount
                  ) +
                  " "
              )
            ])
          ])
        : _vm._e(),
      _vm.fromLogin
        ? [
            _vm.isLoggedIn &&
            _vm.isMainUserIdentity &&
            _vm.userTypes.length === 0
              ? _c("omegaup-user-objectives-questions", {
                  on: {
                    submit: function(objectives) {
                      return _vm.$emit("update-user-objectives", objectives)
                    }
                  }
                })
              : _vm._e(),
            _vm.isLoggedIn && _vm.nextRegisteredContest !== null
              ? _c("omegaup-user-next-registered-contest", {
                  attrs: {
                    "next-registered-contest": _vm.nextRegisteredContest
                  },
                  on: {
                    redirect: function(alias) {
                      return _vm.$emit(
                        "redirect-next-registered-contest",
                        alias
                      )
                    }
                  }
                })
              : _vm._e(),
            _vm.mentorCanChooseCoder
              ? _c(
                  "div",
                  {
                    staticClass: "alert alert-info alert-dismissible fade show",
                    attrs: { role: "alert" }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "data-dismiss": "alert" }
                      },
                      [_vm._v(" × ")]
                    ),
                    _c("omegaup-markdown", {
                      attrs: {
                        markdown: _vm.T.coderOfTheMonthCanBeChosenManually
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e(),
      _c("omegaup-logout-confirmation", {
        model: {
          value: _vm.logoutModalVisible,
          callback: function($$v) {
            _vm.logoutModalVisible = $$v
          },
          expression: "logoutModalVisible"
        }
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "navbar-toggler mr-2",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": ".omegaup-navbar",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }